<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @beforeEnter="beforeEnter"
    @afterLeave="afterLeave"
  >
    <div :class="classes" v-if="show">
      <div class="modal-background"></div>
      <div class="modal-content">
        <p class="image loading-gif"><img src="../../../assets/images/loading.gif"></p>
      </div>
    </div>
  </transition>
</template>

<script>
  import { BaseModal } from 'vue-bulma-modal'

  export default {
    mixins: [BaseModal],

    props: {
      closable: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      classes () {
        return ['modal', 'animated', 'is-active']
      }
    }
  }
</script>
<style>
  .loading-gif {
    width: 15%;
    height: auto;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// LoadModal.vue?4f763b05